// create a page to show success message for cancelled tickets
import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
const CancelSuccess = () => {                              
  return (
    <Container role="main" className="cancel-success-container p-5">
      <Row className="justify-content-center">
        <Col md={6} className="text-center">
          <h1 className="cancel-success-title">Ticket Cancellation Successful</h1>
          <p className="cancel-success-message">
            Your ticket has been successfully cancelled. We hope to see you again soon!
          </p>
          <Link to="/" className="btn btn-primary cancel-success-home-link">
            Back to Home
          </Link>
        </Col>
      </Row>
    </Container>
  );
}
export default CancelSuccess;
// This component displays a success message after a ticket cancellation
// and provides a link to return to the home page. It uses Bootstrap for styling.
// The component is structured with a container, row, and column to center the content. 